import React from "react";
import type { KeyDecision } from "../../data/caseStudies";
import { CaseStudySection } from "./CaseStudySection";
import { Prose } from "./Prose";
import { BODY, H3 } from "../../utils/typography";
type KeyDecisionsProps = {
  decisions: KeyDecision[];
};
export function KeyDecisions({
  decisions
}: KeyDecisionsProps) {
  return <CaseStudySection label="Key Decisions" data-id="element-119" data-mp="12s3tfrksy9gx">
      <ol className="space-y-16 md:space-y-20" data-id="element-120" data-mp="yqs29hma5g6m">
        {decisions.map(d => <li key={d.title} className="max-w-2xl" data-id="element-121" data-mp="yop3o972aeqa">
            <h3 className={`${H3} text-espresso`} data-id="element-122" data-mp="tqxe3ltw34p9">
              {d.title}
            </h3>
            {d.lede && <p className={`mt-4 ${BODY} font-medium text-espresso`} data-id="element-123" data-mp="otdu05aifxpe">{d.lede}</p>}
            <div className="mt-4" data-id="element-124" data-mp="jvc4p2mhr25h">
              <Prose body={d.body} data-id="element-125" data-mp="2j6wp78h2j47j" />
            </div>
            {d.closing && <p className={`mt-6 ${BODY} font-medium text-rust`} data-id="element-126" data-mp="2j4slorn3077s">{d.closing}</p>}
          </li>)}
      </ol>
    </CaseStudySection>;
}